import { ChatSession } from "types/ChatbotTypes";
import { DatasetDto } from "app/ApiClient";

export interface ChatbotState {
  isOpen: boolean;
  panelWidth: number;
  sessions: Record<string, ChatSession>;
  activeDatasetId: string | null;
  isLoading: boolean;
  availableDatasets: DatasetDto[];
  availableDatasetsLoading: boolean;
}

export const initialChatbotState: ChatbotState = {
  isOpen: false,
  panelWidth: 400,
  sessions: {},
  activeDatasetId: null,
  isLoading: false,
  availableDatasets: [],
  availableDatasetsLoading: false,
};
